// Simple resolver of API url
// Points to the backend address depending on the url
const apiUrlResolver = () => {
  // return 'https://api-test.isotopeticketing.com'
  // return 'http://localhost:8081'
  switch (location.hostname) {
    case "localhost":
      return "http://localhost:8081";
    default:
      return "https://api.isotopeticketing.com";
  }
};

// Simple resolver of API url
const wsUrlResolver = () => {
  switch (location.hostname) {
    case "localhost":
      return "ws://localhost:9000";
    case "127.0.0.1":
      return "ws://127.0.0.1:9000";
    case "192.168.0.185":
      return "ws://192.168.0.185:9000";
    default:
      return "ws://api.isotopeticketing.com/subscriptions";
  }
};

// Used mainly for resolving the base name for all url's used in the app
const linkURLResolver = () => {
  switch (location.hostname) {
    case "localhost":
      return "http://localhost:3000";
    case "127.0.0.1":
      return "http://127.0.0.1:3000";
    case "test.isotopeticketing.com":
      return "https://test.isotopeticketing.com";
    default:
      return "https://app.isotopeticketing.com";
  }
};

export const AppConfig = {
  apiUrl: apiUrlResolver(),
  hostUrl: linkURLResolver(),
  ws: {
    url: wsUrlResolver(),
    path: "/data-sync"
  }
};

export const __DEV__ =
  location.hostname === "localhost" || location.hostname === "127.0.0.1";


// WEBPACK FOOTER //
// ./src/config/app.ts